import React, { useEffect, useState } from "react";
import { CustomerNote } from "../model/CustomerNoteModel";
import { Button, Column, DateTimePicker, Label, Row, TextField } from "../../components";
import * as label from '../../shared/util/label';
import moment from "moment";
import ValidateCustomerNote from "./CustomerNoteValidate";
import commonFunctions from "../../shared/hooks/commonFunction";
import { CommonUtility } from "../../Services/CommonUtility";


const NoteEdit: React.FunctionComponent<any> = (props) => {
    const validate = new ValidateCustomerNote()
    const [customerNote, setNote] = useState<CustomerNote>(props.Note);
    const [validateDescription, setDescriptionValidation]=useState({isValid:true, warningText : ""})
    const [validateNoteDate, setValidateNoteDate]=useState({isValid:true, warningText : ""})
    const [validFlag, setValidFlag]=useState(false)

    const onNoteChange = (name: string, value: string | Date | boolean | number) => {
        if(name === 'noteDate' && value !== null ){
            let func = new commonFunctions();
            let validDate = func.ValidateMaxDate(value)
            if(!validDate){
                value = null;
            }
        }
        setNote({ ...customerNote,[name]: value, })
        props.setFormSaved(false)
      }
     
      useEffect(() => {
      if(validateDescription.isValid && validateNoteDate.isValid){
        setValidFlag(true)
      }
      else{
        setValidFlag(false)
      }
    }, [validateDescription.isValid,validateNoteDate.isValid])

    const validateNoteEdit = () =>{
        var descriptionStatus=validate.validateDescription(customerNote.note)
        let descriptionValidationState = {isValid : descriptionStatus.isValid, warningText :descriptionStatus.warningText};
        setDescriptionValidation(validState =>  descriptionValidationState);

        let date = customerNote.noteDate?new Date(moment(customerNote.noteDate.toString()).format("MM/DD/YYYY")):null
        var dateStatus =validate.validateNoteDate(date)
        let dateValidattionState = {isValid : dateStatus.isValid, warningText :dateStatus.warningText};
        setValidateNoteDate(validState => dateValidattionState);

        return descriptionStatus.isValid && dateStatus.isValid;
    }

    const SaveEditedNote =() => {

        let valStatus = validateNoteEdit();
        if (!valStatus){
            return;
        }
        if(valStatus){
            if (customerNote.id !== undefined)
                props.UpdateEditedNote(customerNote)
            else
            {
                props.AddNote(customerNote)
            }
        }
    }

    // useEffect(() => {
    //     validateNoteEdit();
    //   },[]);
    
    return (
        <>
            <div className="nopadding">
                <Row className="mt-3">
                    <Column lg={6} md={6} className="ml-3">
                        <b> <Label isRequired={true} htmlFor="description" title={label.CustomerMemosLabel.DESCRIPTION} text={label.CustomerMemosLabel.DESCRIPTION}></Label></b>
                    </Column>
                </Row>
                <Row>
                    <Column lg={12} md={12} className="ml-4 pl-1" >
                        <TextField
                            name='noteDescription'
                            id="noteDescription"
                            autofocus
                            title={customerNote.note}
                            disabled={false}
                            style={{ fontSize: "14px", width: "96%", height: "200px", resize: "none" }}
                            placeholder={label.CustomerMemosLabel.DESCRIPTION}
                             onChange={(event) => onNoteChange('note', event.currentTarget.value)}
                            tabIndex={2}
                            className='cstCollection'
                            maxLength={2000}
                            value={customerNote.note}
                            isInvalid={!validateDescription.isValid}
                            invalidWarning={validateDescription.warningText}
                        />
                    </Column>
                </Row>
                <Row className="mt-3">
                    
                    <Column lg={6} md={6}>
                        <Row>
                            <Column lg={3} md={3} >
                                <b><Label isRequired={true} text={label.CustomerMemosLabel.MEMO_DATE} /></b>
                            </Column>
                            <Column lg={8} md={8} className="nopadding-left ml-n2 cstNoteDate" >
                                <DateTimePicker
                                tabIndex={3}
                                   // dateFormat="MM/dd/yyyy"
                                    dateFormatCalendar="LLLL yyyy"
                                    dropdownMode="scroll"
                                    //selected={customerNote.noteDate}
                                    selected={CommonUtility.datetimeToDateOnlyObject(customerNote.noteDate)}
                                    minDate={new Date()}
                                    onChange={(date) => onNoteChange('noteDate', date)}
                                    isInvalid={!validateNoteDate.isValid}
                                    invalidWarning={validateNoteDate.warningText}
                                    //onChangeRaw={(event)=> onNoteChange('noteDate', event.target.value) }
                                    >
                                        
                                    </DateTimePicker>
                            </Column>
                        </Row>
                    </Column>
                </Row>

                <Row className="mt-3">
                    <Column lg={8} md={8}>
                        <Button
                            className='btn btn-outline-tertiary ml-3 action-btn-base'
                            key="filter"
                            onClick={() => props.CancelNote()}
                            tabIndex={4}
                            id="btnNotesCancel"
                            color='primary'
                            outlined={true}
                        >{label.CANCEL.toLocaleUpperCase()}
                        </Button>

                    </Column>
                    <Column lg={4} md={4} className="text-right">
                        <Button
                            className='btn btn-primary mr-2 action-btn-base'
                            key="filter"
                            onClick={() => SaveEditedNote()}
                            tabIndex={5}
                            id="btnAddNotes"
                            color='primary'
                            keyDown={(e) => {
                                if (e.key == "Tab" && !e.shiftKey) {
                                    document.getElementById("btnNotesAdd").focus();
                                    e.preventDefault();
                                }
                            }}
                        >{label.SAVE.toLocaleUpperCase()}
                        </Button>
                    </Column>
                </Row>
            </div>
        </>
    )

}

export default NoteEdit;